import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Modal, InputGroup } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../CommonCSS/SocietyCSS.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';
import SearchLCModal from './SearchLC_Modal';
import PRINT_LEAVE_CERT from './Print_Leave_Cert';

const Leave_Cert = () => {

  const initialFormData = {
    leave_cert_id: "",
    leave_cert_date: new Date().toISOString().split("T")[0],
    year1: "",
    year2: "",
    section_id: "",
    gr_no: "",
    leave_reason_id: "",
    leave_reason: "",
    std_studying_since: "",
    conduct: "",
    progress: "",
    remarks: "",
    status: "NEW",
    display_year: "",
    stud_name: "",
    std_div: "",
  };

  const [lcPrintData, setLCPrintData] = useState({
    leave_cert_id: "1",
    leave_cert_date: new Date().toISOString().split("T")[0],
    year1: "2024",
    year2: "2025",
    section_id: "1",
    gr_no: "1234",
    stud_name: "Anis",
    student_id: "123456",
    std_name: "8",
    aadhar_no: "1234 5678 91123",
    father_name: "Father",
    father_surname: "Khan",
    mother_name: "Mother",
    nationality: "",
    mother_tongue: "",
    religion: "",
    caste: "",
    sub_caste: "",
    place_of_birth: "",
    date_of_birth: "",
    district: "",
    last_school: "",
    adm_date: "",
    leave_reason_id: "",
    leave_reason: "",
    std_studying_since: "",
    conduct: "",
    progress: "",
    remarks: "",
  });

  const [showsearchModal, setShowSearchModal] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [formData, setFormData] = useState(initialFormData);

  const [ddlSections, setDdlSections] = useState([]);
  const [ddlGRNos, setDdlGRNos] = useState([]);
  const [currYear1, setCurrYear1] = useState();

  const [showLCPrint, setShowLCPrint] = useState(false);

  useEffect(() => {
    loadDropdowns();
  }, []);
  
  const loadDropdowns = async () => {
    try {

      const sec = await axios.get(`${BASE_URL}/api/ddl_sections`);
      setDdlSections(sec.data);

      const year_result = await axios.get(`${BASE_URL}/api/ddl_open_year`);

      setFormData(prev => ({
        ...prev,
        display_year : year_result.data[0].disp_year,
        year1: year_result.data[0].year1,
        year2: Number(year_result.data[0].year1) + 1,
      }));

      setCurrYear1(year_result.data[0].year1);

    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {

    const fetchLists = async () => {
      try {

        setDdlGRNos([]);

        setFormData(prev => ({
          ...prev,
          display_year: prev.display_year,
          year1: prev.year1,
          year2: prev.year2,
          section_id: formData.section_id,
          gr_no: "",
          stud_name: "",
          std_div: "",
        }));

        if (!formData.section_id) return;

        const studResponse = await axios.get(`${BASE_URL}/api/ddl_stud_name_gr`,
          { params: { p_Section_Id: formData.section_id } });

        setDdlGRNos(studResponse.data);

      } catch (err) {
        console.error("Search fetch error:", err);
      }
    };

    fetchLists();

  }, [formData.section_id]);

  const handleGrChange = async (selectedOption) => {

    try {

      setFormData(prev => ({
        ...prev,
        gr_no: selectedOption ? selectedOption.value : "",
        stud_name: selectedOption ? selectedOption.label : ""
      }));

      const val_result = await axios.get(`${BASE_URL}/api/validate_gr_lc`, 
        { params: { p_section_id: formData.section_id, p_gr_no: selectedOption.value } }
      );

      if (val_result.data.length > 0) {
        toast.error('LC No. ' + val_result.data[0].leave_cert_id + ' already exists for the seleted student.')
      }

     // retrieveFeeDetails(headerData.section_id, selectedOption.value);

    } catch (e) {
      toast.error('Unable to retrieve student.');
    }

  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleNew = () => {

    pageReset();
    setIsEditable(true);

  };

  const handleClear = () => {

    if (!window.confirm("Clear form?")) return;
    pageReset();
    setIsEditable(false);

  };

  const pageReset = () => {

    const lv_curr_year1 = currYear1;

    setFormData(prev => ({
      ...prev,
      leave_cert_id: "",
      leave_cert_date: new Date().toISOString().split("T")[0],
      display_year: lv_curr_year1 + '-' + Number(lv_curr_year1) + 1,
      year1: lv_curr_year1,
      year2: Number(lv_curr_year1) + 1,
      section_id: "",
      gr_no: "",
      stud_name: "",
      std_div: "",
      leave_reason_id: "",
      leave_reason: "",
      std_studying_since: "",
      conduct: "",
      progress: "",
      remarks: "",
      status: "NEW",
    }));

    setDdlGRNos([]);

  }

  const handleSave = async () => {

    const val_result = await axios.get(`${BASE_URL}/api/validate_gr_lc`,
      { params: { p_section_id: formData.section_id, p_gr_no: formData.gr_no } }
    );

    if (val_result.data.length > 0) {
      toast.error('LC No. ' + val_result.data[0].leave_cert_id + ' already exists for the seleted student.')
      return;
    }

    if (!formData.leave_cert_date) {
      toast.error("Please enter LC Date.");
      return;
    } else if (!formData.stud_name) {
      toast.error("Please select GR No./Student.");
      return;
    } else if (!formData.std_studying_since) {
      toast.error("Please enter Studying Since.");
      return;
    } else if (!formData.leave_reason) {
      toast.error("Please enter Leave Reason.");
      return;
    } else if (!formData.conduct) {
      toast.error("Please enter Conduct.");
      return;
    } else if (!formData.progress) {
      toast.error("Please enter Progress.");
      return;
    } else if (!formData.remarks) {
      toast.error("Please enter Remarks.");
      return;
    }

    if (!window.confirm("Sure you want to create LC ?")) return;

    try {
      const response = await axios.post(`${BASE_URL}/api/save_leaving_cert`, formData);
      if (response.data.message !== '0') {
        toast.success('LC No. ' + response.data.message + ' saved successfully.');
        pageReset();
        setIsEditable(false);
      } else {
        toast.error('Unable to save LC.');
      }
    } catch (err) {
      console.error(err);
      toast.error("Error saving LC.");
    }
  };

  const handleRowSelect = async (selRow) => {

    try {

      setShowSearchModal(false);

      const response = await axios.get(`${BASE_URL}/api/get_lc_ByLCNo`, {
        params: { p_section_id: selRow.section_id, p_lc_no: selRow.lc_no },
      });

      const studResponse = await axios.get(`${BASE_URL}/api/ddl_stud_name_gr`,
        { params: { p_Section_Id: selRow.section_id } });

      setDdlGRNos(studResponse.data);

      //formData.

      setFormData({
      leave_cert_id: response.data[0].leave_cert_id,
      leave_cert_date: response.data[0].leave_cert_date,
      year1: response.data[0].year1,
      year2: response.data[0].year2,
      section_id: response.data[0].section_id,
      gr_no: response.data[0].gr_no,

      stud_name: studResponse.data[0].stud_name,

      leave_reason_id: response.data[0].leave_reason_id,
      leave_reason: response.data[0].leave_reason,
      std_studying_since: response.data[0].std_studying_since,
      conduct: response.data[0].conduct,
      progress: response.data[0].progress,
      remarks: response.data[0].remarks,
      status: response.data[0].status,
      display_year: response.data[0].year1 + '-' + response.data[0].year2,
      std_div: response.data[0].std_div,
      });


      setIsEditable(true);

    } catch (err) {
      console.error(err);
    }

  };

  const handleLCPrintClose = () => {

    setShowLCPrint(false);

    // if (resetAfterClose) {
    //   resetPage();
    //   setResetAfterClose(false);
    // }

  };
  
  const grNoOptions = ddlGRNos.map(code => ({
    value: String(code.gr_no),
    label: code.stud_name
  })) || [];

  return (
    <Container fluid className="p-3" style={{ maxHeight: "90vh", overflowY: "auto" }}>

      {/* ================= LEAVING CERTIFICATE ================= */}
      <Card className="mb-4">

        <Card.Body>

          <Row className="mb-3">

            <Col md={3}><InputGroup>
              <InputGroup.Text style={{ width: "130px" }}> LC No
              </InputGroup.Text>
              <input name="leave_cert_id" className="form-control" value={formData.leave_cert_id} disabled />
            </InputGroup>
            </Col>

            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}> Status
                </InputGroup.Text>
                <select name="status" className="form-select" value={formData.status} disabled >
                  <option value="NEW">New</option>
                  <option value="APPR">Approved</option>
                </select>
              </InputGroup>
            </Col>

            <Col md={3}><InputGroup>
              <InputGroup.Text style={{ width: "150px" }}> Year
              </InputGroup.Text>
              <input name="display_year" className="form-control" value={formData.display_year} disabled/>
            </InputGroup>
            </Col>
            
            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "130px" }}> LC Date <span style={{ color: "red" }}>*</span>
                </InputGroup.Text>
                <input type="date" name="leave_cert_date" className="form-control"
                  value={formData.leave_cert_date} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

          </Row>

          <Row className="mb-3">

            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "130px" }}>
                  Section<span style={{ color: "red" }}>*</span>
                </InputGroup.Text>
                <select name="section_id" className="form-select" value={formData.section_id}
                  onChange={handleChange} disabled={!isEditable} >
                  <option value="">-- Select --</option>
                  {ddlSections.map(s => ( <option key={s.section_id} value={s.section_id}> {s.section_desc} </option> ))}
                </select>
              </InputGroup>
            </Col>

            <Col md={9}>
            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}> GR No./ Name <span style={{ color: "red" }}>*</span>
              </InputGroup.Text>

              <div style={{ flex: 1 }}>
                <Select name="gr_no"  isDisabled={!isEditable}
                  styles={{ singleValue: (provided) => ({ ...provided, color: "blue", }), }}
                  options={grNoOptions}
                  value={grNoOptions.find(option => String(option.value) === String(formData.gr_no)) || null}
                  onChange={handleGrChange} placeholder="Search by GR No / Student name ..." />
              </div>
            </InputGroup>
            </Col>

          </Row>

          <Row className="mb-3">

            <Col md={6}>

              <InputGroup>
                <InputGroup.Text style={{ width: "130px" }}> Studying Since<span style={{ color: "red" }}>*</span>
                </InputGroup.Text>
                <input name="std_studying_since" className="form-control"
                  value={formData.std_studying_since} onChange={handleChange}
                  disabled={!isEditable} />
              </InputGroup>

            </Col>

            <Col md={6}>

              <InputGroup>      
                <InputGroup.Text style={{ width: "150px" }}> Leave Reason<span style={{ color: "red" }}>*</span>
                </InputGroup.Text>
                <input name="leave_reason" className="form-control" value={formData.leave_reason}
                   onChange={handleChange} disabled={!isEditable} />
              </InputGroup>

            </Col>

          </Row>

          <Row className="mb-3">

            <Col md={6}>

              <InputGroup>
                <InputGroup.Text style={{ width: "130px" }}>
                  Conduct<span style={{ color: "red" }}>*</span>
                </InputGroup.Text>
                <input name="conduct" className="form-control" value={formData.conduct}
                  onChange={handleChange} disabled={!isEditable} />
              </InputGroup>

            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}> Progress<span style={{ color: "red" }}>*</span>
                </InputGroup.Text>
                <input name="progress" className="form-control" disabled={!isEditable}
                  value={formData.progress} onChange={handleChange} />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "130px" }}>
                  Remarks<span style={{ color: "red" }}>*</span>
                </InputGroup.Text>
                <textarea
                  name="remarks"
                  className="form-control"
                  rows="1"
                  value={formData.remarks}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>
          </Row>

          {/* ================= ACTION BUTTONS ================= */}

          <div className="d-flex justify-content-end gap-2 mt-3 flex-wrap">

            <button type="button" className="btn btn-primary" style={{ width: "135px" }}
              onClick={handleNew} disabled={isEditable} > New </button>

            <button type="button" className="btn btn-warning" style={{ width: "135px" }}
              onClick={(e) => (setShowSearchModal(true))}
              disabled={isEditable} > Edit </button>
            {showsearchModal && (
              <SearchLCModal
                show={showsearchModal}
                handleClose={() => setShowSearchModal(false)}
                onRowSelect={handleRowSelect}
              />
            )}

            <button type="button" className="btn btn-info" style={{ width: "135px" }}
              // onClick={handlePreview}
              disabled={!formData.gr_no} > Preview LC </button>

            <button type="button" className="btn btn-dark" style={{ width: "135px" }}
               onClick={(e) => (setShowLCPrint(true))} > Print LC </button>
              
            {showLCPrint && (
              <Modal show={showLCPrint}
                onHide={handleLCPrintClose} size="xl">
                <Modal.Header closeButton>
                  <Modal.Title>Print Leave Certificate</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <PRINT_LEAVE_CERT
                    lcDetails={lcPrintData}
                    onAfterPrint={() => { setTimeout(() => { handleLCPrintClose(); }, 1000); }}
                  />
                </Modal.Body>
              </Modal>
            )}

            <button type="button" className="btn btn-secondary" style={{ width: "135px" }}
              onClick={handleClear} > Clear </button>

            <button type="button" className="btn btn-success" style={{ width: "135px" }}
              onClick={handleSave} disabled={!isEditable} > Save </button>
          </div>

        </Card.Body>
      </Card >

    </Container >
  );
};

export default Leave_Cert;
